import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NestedSubnavComponent } from '@app/modules/menu-mobile/nested-subnav.component';
import { MenuMobileComponent } from './menu-mobile.component';


const routes: Routes = [
  {
    path: '',
    component: MenuMobileComponent,
  },
  {
    path: 'direct-mobile',
    component: NestedSubnavComponent,
    data: {
      id: 'direct-mobile',
      title: 'Direct',
    }
  },
  {
    path: 'device-mobile',
    component: NestedSubnavComponent,
    data: {
      id: 'device-mobile',
      title: 'Devices',
    }
  },
  {
    path: 'gx-mobile',
    component: NestedSubnavComponent,
    data: {
      id: 'gx-mobile',
      title: 'Guest experience',
    }
  },
  {
    path: 'ops-mobile',
    component: NestedSubnavComponent,
    data: {
      id: 'ops-mobile',
      title: 'Operations',
    }
  },
  {
    path: 'settings-mobile',
    component: NestedSubnavComponent,
    data: {
      id: 'settings-mobile',
      title: 'Settings',
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MenuMobileRoutingModule { }
